module.exports = __webpack_public_path__ + "assets/944516a27df697ce7e8cb56f731242ac.jpg";